
<marv-drawer #drawerStoreFilters (onDidDismiss)="this.onDidDismissDrawerFilters($event)">
    <div class="title_card">{{'FILTER_STORES' | translate}}</div>    
    <app-store-filters [operations]="this.operations" [storeFiltersValues]="this.storeFiltersValues" (onChangeStoreFilters)="this.onChangeStoreFilters($event)" />
</marv-drawer>

<ion-grid class="no_padding" id="stores_list_title" [class.with_type_mission_legend]="this.displayNbInterventions">        
    <ion-row class="ion-align-items-center ion-justify-content-between"> 
        <ion-col size="auto" class="title_card">
            {{'STORE_LIST' | translate}}
            <marv-circle>{{this.storesToDisplay.length}}</marv-circle>
            
        </ion-col>
        <ion-col size="auto" class="no_padding">
            <marv-button label="{{'FILTER_STORES' | translate}}{{(this.storeFiltersValues.nbFiltersFilled > 0 ? ' ('+this.storeFiltersValues.nbFiltersFilled+')' : '')}}" icon="search-outline" hideLabelDevice="phone" (click)="this.showStoresFilters()" />
        </ion-col>
    </ion-row>
    @if(this.displayNbInterventions){
        <ion-row>
            <app-type-mission-legend />
        </ion-row>
    }
</ion-grid>

@if(this.isFetching){
    <div class="bloc_loading">
        <ion-spinner></ion-spinner>
    </div>        
}
@else {
    @if(this.storesDisplayed.length > 0){
        <div class="ion-content-scroll-host" id="stores_list" [class.with_type_mission_legend]="this.displayNbInterventions">
            @for(store of this.storesDisplayed; track store.id){
                <app-store-item [store]="store" [displayNbInterventions]="this.displayNbInterventions" [displayScores]="true" (onSelectStore)="this.selectStore($event)" />
            } 
            <ion-infinite-scroll (ionInfinite)="this.onIonInfinite($event)" [disabled]="this.disabledInfiniteScroll">
                <ion-infinite-scroll-content></ion-infinite-scroll-content>
            </ion-infinite-scroll>
        </div>        
    }
    @else{
        <marv-message type="info">{{'MSG_NO_STORE' | translate}}</marv-message>
    }
}
